module.exports = __webpack_public_path__ + "static/media/shortinglistdown-white.b8d8264b.svg";